import React, { useState } from 'react';
import { Form, Container, Row, Col, Alert } from 'react-bootstrap';
import { useAuth } from '../common/AuthProvider';
import { useHistory, Link } from 'react-router-dom';
import '../styles.css';


const LoginPage = () => {

  const history = useHistory();
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await login(email, password);
    if (response.result) {
      history.push('/spaces');
    } else {
      var e = response.status === 401 ? 'Invalid email or password':
      response.status === 404 ? 'User not found' : 
      response.status === 500 ? 'Internal server error' : 'Login failed';
      setError(e);
    }
  }

  return (
    <Container>
      <Row className="justify-content-md-center mt-5">
        <Col xs={12} md={6}>
          <h2 className="text-center mb-4">Login</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
              />
            </Form.Group>
            <div style={{width: "100% !important"}}>
              <button style={{width: "100%", minWidth: "100%"}} 
                type="submit" className='btn-custom green'>Login</button> 
            </div>
          </Form>
          <div>
          <p style={{marginTop: '0.5rem'}}> Don't have an account? <Link to="/sign-up">Sign up</Link> </p>
          </div>
        </Col>
      </Row>
    </Container>

  );
};

export default LoginPage;
